/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateOrUpdateMerchantWorkweekConfigurationRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {CreateOrUpdateMerchantWorkweekConfigurationResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const createOrUpdateMerchantWorkweekConfiguration = (request: CreateOrUpdateMerchantWorkweekConfigurationRequest, options?: CashRequestOptions) => post<CreateOrUpdateMerchantWorkweekConfigurationRequest, CreateOrUpdateMerchantWorkweekConfigurationResponse>("/proxy/services/squareup.timecards.TimeCalculationService/CreateOrUpdateMerchantWorkweekConfiguration", request, {...options, rejectOnError: true })